var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('Header'),_c('div',{staticClass:"error-container"},[_c('div',{staticClass:"error-message"},[_c('em',{staticClass:"icon icon-balls"}),_c('span',[_vm._v(_vm._s(_vm.errorPageMessage))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }